module.exports = __webpack_public_path__ + "assets/Kappa.0f016c0d1865cc3df075b7c094ff99f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Kappa.png
// module id = 836
// module chunks = 0